<template>
  <div class="video-crawler-tag-example-container mt-2">
    <div class="video-crawler-tag-example">
      <div v-if="tag === 'meta' && !invalidAttribute">
        <code>&lt;meta {{ attributeKey }}="{{ attributeValue }}" /></code>
      </div>
      <div v-else-if="tag === 'meta' && invalidAttribute">
        <code>&lt;meta /></code>
      </div>
      <div v-else-if="tag !== 'meta' && invalidAttribute">
        <code>&lt;{{ tag }}>Your video detail here&lt;{{ tag }}></code>
      </div>
      <div v-else>
        <code>&lt;{{ tag }} {{ attributeKey }}="{{ attributeValue }}">Your video detail here&lt;/{{ tag }}></code>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: ['tag', 'attributeKey', 'attributeValue'],
  computed: {
    invalidAttribute() {
      return _.isEmpty(this.attributeKey) || _.isEmpty(this.attributeValue);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
